import React from 'react';
import {
  StyledCloseButton,
  StyledDebugHeader,
  StyledDebugPanel,
} from './DebugPanel.styles';

export type DebugPanelProps = {
  title: string;
  onClose?: () => void;
};

export const DebugPanel: React.FunctionComponent<
  React.PropsWithChildren<DebugPanelProps>
> = ({ title, onClose, children }) => {
  return (
    <StyledDebugPanel>
      <StyledDebugHeader>
        <h3>{title}</h3>
        <StyledCloseButton onClick={onClose}>×</StyledCloseButton>
      </StyledDebugHeader>

      {children}
    </StyledDebugPanel>
  );
};
